import { render, staticRenderFns } from "./AddDeliveryMethod.vue?vue&type=template&id=2d79632a&"
import script from "./AddDeliveryMethod.vue?vue&type=script&lang=js&"
export * from "./AddDeliveryMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports